/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('WallCtrl', function($scope, $uibModal, ngNotify, identity, ErrorThrower, Conversation) {
    $scope.authorized = true;
    const error_manager     = new ErrorThrower({
        'No message provided': 'Le contenu du message est manquant',
        'No title provided':   'Le titre de la conversation est manquant'
    });

    // plus doptions = date
    $scope.fetchFilters = () => $scope.statsFunc($scope.params)
        .$promise
        .then(function(stats) {
            $scope.filters['smart-acls'].available = stats.acls_stats;
            return $scope.filters.tags.available          = stats.conversation_tags;}).catch(api_error => error_manager.minor(api_error.statusText));

    $scope.addSelectedFilter = function(filter, index) {
        const filter_isnt_selected = $scope.filters[index].select.every(current_filter => current_filter.term !== filter.term);

        if (filter_isnt_selected) {
            $scope.filters[index].select.push(filter);
            const current_filter_indice = $scope.filters[index].available.indexOf(filter);
            return $scope.filters[index].available.splice(current_filter_indice, 1);
        }
    };

    $scope.invertSelectedFilter = function(filter, index) {
        const filter_isnt_unselected  = $scope.filters[index].unselect.every(current_filter => current_filter.term !== filter.term);

        if (filter_isnt_unselected) {
            $scope.filters[index].unselect.push(filter);
            const current_filter_indice = $scope.filters[index].select.indexOf(filter);
            return $scope.filters[index].select.splice(current_filter_indice, 1);
        }
    };

    $scope.removeSelectedFilter = function(filter, index) {
        const current_select_indice = $scope.filters[index].unselect.indexOf(filter);
        $scope.filters[index].unselect.splice(current_select_indice, 1);
        if ($scope.filters[index].available.every(current_filter => current_filter.term !== filter.term)) { return $scope.filters[index].available.push(filter); }
    };

    $scope.fetchWithSelectedFilters = function() {
        let input_filter;
        let new_query       = '';

        if ($scope.filtered) { input_filter = $scope.filtered; }
        if ($scope.filters.moulinette) { new_query   += '-metas.moulinette:true'; }
        const before       = moment($scope.filters.before).format();
        const after        = moment($scope.filters.after).format();
        let created_at   = ' +created_at:[d1 TO d2]';
        created_at   = created_at.replace('d1', ($scope.filters.after != null) ? after : '*');
        created_at   = created_at.replace('d2', ($scope.filters.before != null) ? before : '*');
        new_query   += created_at;

        if ($scope.filters.only_unread) { new_query += ` -last_message.views:${identity.id}`; }
        if (false === $scope.filters.stage_validation) { new_query += ' -metas.has_stage_validation:true'; }

        for (let metas_type of ['smart-acls', 'tags']) {
            const filters = $scope.filters[metas_type];
            for (let selected of Array.from(filters.select)) {
                new_query += ` +metas.${metas_type}:\"${selected.term}\"`;
            }
            for (let unselected of Array.from(filters.unselect)) {
                new_query += ` -metas.${metas_type}:\"${unselected.term}\"`;
            }
        }

        $scope.params.q              = new_query;
        $scope.params.messages_query = input_filter;
        $scope.conversations         = [];
        return $scope.from                  = 0;
    };

    const clearList = function(list) {
        list.available = list.available.concat(list.select, list.unselect);
        list.select    = [];
        return list.unselect  = [];
    };

    $scope.clearFilters = function() {
        clearList($scope.filters['smart-acls']);
        clearList($scope.filters.tags);

        $scope.filters.moulinette       = false;
        $scope.filters.only_unread      = false;
        $scope.filters.stage_validation = true;
        $scope.filtered                 = '';
        $scope.filters.before           = null;
        $scope.filters.after            = null;
        $scope.params.q                 = '';

        if (0 === $scope.total) { $scope.from = null; }
        return $scope.fetch();
    };

    $scope.fetch = function() {
        if ((true === $scope.fetching) || ($scope.total === $scope.from) || !$scope.type) { return; }
        $scope.fetching = true;
        const params          = angular.extend({ }, $scope.params, { from: $scope.from, size: $scope.size });
        return $scope.fetchFunc(params)
        .$promise
        .then(function(result) {
            $scope.authorized    = true;
            $scope.from         += result.hits.length;
            $scope.conversations = $scope.conversations.concat(result.hits);
            return $scope.total         = result.total;}).catch(function(api_error) {
            $scope.authorized = ![401, 403].includes(api_error.status);
            if (404 === api_error.status) {
                return $scope.total = 0;
            } else {
                return error_manager.minor(api_error.statusText);
            }}).finally(() => $scope.fetching = false);
    };

    $scope.createConversation = function() {
        const modal_instance = $uibModal.open({
            templateUrl: 'directives/conversations/message-preview/modal-template.html',
            controller:  'MessagePreviewCtrl',
            size:        'lg',
            resolve: {
                message() {
                    return $scope.new_conversation.content;
                },
                acl_empty() {
                    return (true === ($scope.new_conversation.circles != null)) && (0 === $scope.new_conversation.circles.length);
                }
            }
        });

        return modal_instance
        .result
        .then(() => $scope.create($scope.params, $scope.new_conversation)
        .$promise
        .then(function(result) {
            $scope.conversations.unshift(result);
            $scope.total           += 1;
            $scope.from            += 1;
            return $scope.new_conversation = { };})
        .catch(function(api_error) {
            const error_message = 400 === api_error.status ? api_error.data : api_error.statusText;
            return error_manager.minor(error_message);
        }));
    };

    $scope.init = function() {
        $scope.conversations      = [];
        $scope.allow_title        = true;
        $scope.allow_acl          = true;
        if (($scope.allow_reply == null)) { $scope.allow_reply        = true; }
        if (($scope.possible_tags == null)) { $scope.possible_tags      = []; }
        $scope.total              = null;
        $scope.from               = 0;
        $scope.size               = 5;
        $scope.fetching           = false;
        $scope.new_conversation   = { };
        $scope.allow_moulinette   = true;
        $scope.is_collapsed       = false;
        $scope.filters            = {
            only_unread:      false,
            stage_validation: true,
            'smart-acls': {
                available: [],
                select:    [],
                unselect:  []
            },
            tags: {
                available: [],
                select:    [],
                unselect:  []
            }
        };

        switch ($scope.type) {
            case 'promo':
                $scope.fetchFunc        = Conversation.getConversations;
                $scope.statsFunc        = Conversation.getConversationsStats;
                $scope.create           = Conversation.create;
                $scope.allow_acl        = false;
                $scope.allow_moulinette = false;
                break;
            case 'user':
                $scope.fetchFunc        = Conversation.getConversations;
                $scope.statsFunc        = Conversation.getConversationsStats;
                $scope.create           = Conversation.create;
                break;
            case 'module':
                $scope.fetchFunc        = Conversation.getModuleConversations;
                $scope.create           = Conversation.createModuleConversation;
                $scope.statsFunc        = Conversation.getModuleConversationsStats;
                break;
            case 'activity':
                $scope.fetchFunc        = Conversation.getProjectConversations;
                $scope.create           = Conversation.createProjectConversation;
                $scope.statsFunc        = Conversation.getProjectConversationsStats;
                break;
            case 'other_wall':
                $scope.fetchFunc        = Conversation.getWallConversations;
                $scope.statsFunc        = Conversation.getWallConversationsStats;
                $scope.create           = Conversation.createWallConversation;
                $scope.allow_acl        = false;
                $scope.allow_moulinette = false;
                break;
        }
        $scope.fetchFilters();
        return $scope.fetch();
    };

    return $scope.$watch('params', () => $scope.init()
    , true);
});
